<!-- Content Area -->
<div class="p-8">
    <div class="flex justify-between items-center mb-6">
        <h1 class="text-xl lg:text-3xl font-bold text-gray-900">Product List</h1>
        <button
            (click)="openAddModal()"
            class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 text-base lg:text-sm font-semibold rounded-lg transition flex items-center gap-2"
        >
            <span>+</span>
            <span>Add Product</span>
        </button>
    </div>

    <!-- Table -->
    <div class="bg-white rounded-lg shadow-sm mb-6 overflow-x-auto scrollbar-hide">
        <table class="w-full">
            <thead>
                <tr class="border-b border-gray-200">
                    <th
                        class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        No
                    </th>
                    <th
                        class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Name
                    </th>
                    <th
                        class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Description
                    </th>
                    <th
                        class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Category
                    </th>
                    <th
                        class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        SKU
                    </th>
                    <th
                        class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Price
                    </th>
                    <th
                        class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Benefit
                    </th>
                    <th
                        class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Status
                    </th>
                    <th
                        class="text-center py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Action
                    </th>
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
                <tr
                    *ngFor="let product of Product; let i = index"
                    class="hover:bg-gray-50 transition-colors"
                >
                    <td class="py-4 px-6 text-sm text-gray-900">
                        {{ (pagination.current_page - 1) * pagination.per_page + i + 1 }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-900">
                        {{ product.name }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-600 relative group cursor-pointer">
                        <span class="block max-w-xs truncate">
                            {{ product.description }}
                        </span>
                        <!-- Tooltip -->
                        <div
                            class="absolute left-0 top-full mt-2 hidden group-hover:block
                                bg-black text-white text-xs p-2 rounded shadow-lg
                                max-w-sm z-50">
                            {{ product.description }}
                        </div>
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-600">
                        {{ product.category.name }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-600">
                        {{ product.sku }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-600">
                        Rp {{ product.price | number }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-600">
                        <div class="px-3 py-2 bg-blue-600 text-white rounded-lg whitespace-nowrap text-center cursor-pointer hover:bg-blue-700 transition" (click)="openModalBenefit(product)">Show Benefit</div>
                    </td>
                    <td class="py-4 px-6 text-sm">
                        <span
                            [class]="product.status === 'active' ? 'px-2 py-1 bg-green-100 text-green-800 rounded text-xs' : 'px-2 py-1 bg-gray-100 text-gray-800 rounded text-xs'"
                        >
                            {{ product.status }}
                        </span>
                    </td>
                    <td class="py-4 px-6">
                        <div class="flex items-center justify-center gap-0">
                            <button
                                (click)="openEditModal(product.id)"
                                class="text-gray-600 hover:text-gray-900 transition-colors border border-[#D5D5D5] py-2 px-3 rounded-l-lg hover:bg-gray-50 flex items-center gap-1 whitespace-nowrap"
                            >
                                <img
                                    src="assets/visidea/icon/pencil-write.png"
                                    class="w-4 h-4 flex-shrink-0"
                                    alt=""
                                    onerror="this.style.display='none'"
                                />
                                <!-- <span class="text-xs">Edit</span> -->
                            </button>
                            <button
                                (click)="deleteProduct(product.id, product.name)"
                                class="text-red-500 hover:text-red-700 transition-colors border border-[#D5D5D5] py-2 px-3 rounded-r-lg hover:bg-red-50 flex items-center gap-1 whitespace-nowrap"
                            >
                                <img
                                    src="assets/visidea/icon/bin.png"
                                    class="w-4 h-4 flex-shrink-0"
                                    alt=""
                                    onerror="this.style.display='none'"
                                />
                                <!-- <span class="text-xs">Delete</span> -->
                            </button>
                        </div>
                    </td>
                </tr>

                <!-- Empty State -->
                <tr *ngIf="Product.length === 0">
                    <td colspan="7" class="py-8 text-center text-gray-500">
                        Tidak ada data product
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Pagination -->
        <div
            class="flex items-center justify-between px-6 py-4 border-t border-gray-200"
        >
            <button
                (click)="previousPage()"
                [disabled]="pagination.current_page === 1"
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <img
                    src="assets/visidea/icon/left.png"
                    class="w-[12px] h-[12px]"
                    alt=""
                />
                <span>Previous</span>
            </button>

            <span class="text-sm text-gray-600">
                Page {{ pagination.current_page }} of {{ pagination.total_page }}
            </span>

            <button
                (click)="nextPage()"
                [disabled]="pagination.current_page === pagination.total_page"
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <span>Next</span>
                <img
                    src="assets/visidea/icon/right.png"
                    class="w-[12px] h-[12px]"
                    alt=""
                />
            </button>
        </div>
    </div>
</div>

<!-- Modal Add/Edit Product -->
<div
    *ngIf="isModalOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
>
    <div
        class="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn"
        (click)="$event.stopPropagation()"
    >
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900">
                {{ isEditMode ? "Edit Product" : "Add New Product" }}
            </h2>
            <button
                (click)="closeModal()"
                class="text-gray-400 hover:text-gray-600 text-2xl"
            >
                &times;
            </button>
        </div>

        <form (ngSubmit)="onSubmit()" #productFormElement="ngForm" class="overflow-y-auto max-h-[80vh] scrollbar-hide">
            <!-- Name -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Name <span class="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    [(ngModel)]="productForm.name"
                    name="name"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter product name"
                />
            </div>

            <!-- Description -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Description <span class="text-red-500">*</span>
                </label>
                <textarea
                    [(ngModel)]="productForm.description"
                    name="description"
                    required
                    rows="3"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter product description"
                ></textarea>
            </div>

            <!-- Price -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Price <span class="text-red-500">*</span>
                </label>
                <div class="relative">
                    <span class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500">Rp</span>
                    <input
                        type="text"
                        [value]="formatCurrency(productForm.price)"
                        (input)="productForm.price = parseCurrency($any($event.target).value)"
                        name="price"
                        required
                        class="w-full pl-12 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="1.600.000"
                    />
                </div>
            </div>

            <!-- SKU -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    SKU <span class="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    [(ngModel)]="productForm.sku"
                    name="sku"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 uppercase"
                    placeholder="Enter SKU (e.g., SLKPB)"
                    style="text-transform: uppercase"
                />
            </div>

            <!-- Slug -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Slug <span class="text-gray-400">(Optional)</span>
                </label>
                <input
                    type="text"
                    [(ngModel)]="productForm.slug"
                    name="slug"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter slug (auto-generated if empty)"
                />
            </div>

            <!-- Category -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Category <span class="text-red-500">*</span>
                </label>
                <select
                    [(ngModel)]="productForm.category_id"
                    name="category_id"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <option value="">Select Category</option>
                    <option *ngFor="let category of Category" [value]="category.id">
                        {{ category.name }}
                    </option>
                </select>
            </div>

            <div class="mb-6">
                <div class="flex justify-between items-center mb-2">
                    <label class="block text-sm font-medium text-gray-700">
                        Benefits <span class="text-gray-400">(Optional)</span>
                    </label>
                    <button
                        type="button"
                        (click)="addBenefit()"
                        class="text-blue-500 hover:text-blue-600 text-sm flex items-center gap-1"
                    >
                        <span>+</span>
                        <span>Add Benefit</span>
                    </button>
                </div>

                <!-- Benefits List -->
                <div class="space-y-2">
                    <div
                        *ngFor="let benefit of getBenefits(); let i = index; trackBy: trackByIndex"
                        class="flex gap-2"
                    >
                        <input
                            type="text"
                            [(ngModel)]="productForm.properties.benefit[i]"
                            [name]="'benefit_' + i"
                            class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="e.g., Unlimited print (2 jam)"
                        />
                        <button
                            type="button"
                            (click)="removeBenefit(i)"
                            class="px-3 py-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition"
                        >
                            ✕
                        </button>
                    </div>

                    <!-- Empty State -->
                    <div
                        *ngIf="getBenefits().length === 0"
                        class="text-sm text-gray-400 text-center py-4 border border-dashed border-gray-300 rounded-lg"
                    >
                        No benefits added. Click "+ Add Benefit" to add one.
                    </div>
                </div>
            </div>

            <!-- Status -->
            <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Status <span class="text-red-500">*</span>
                </label>
                <select
                    [(ngModel)]="productForm.status"
                    name="status"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <option value="inactive">Inactive</option>
                    <option value="active">Active</option>
                </select>
            </div>

            <!-- Buttons -->
            <div class="flex gap-3">
                <button
                    type="button"
                    (click)="closeModal()"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <span *ngIf="!isSubmitting">
                        {{ isEditMode ? "Update" : "Create" }}
                    </span>
                    <span *ngIf="isSubmitting">Processing...</span>
                </button>
            </div>
        </form>
    </div>
</div>

<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" (click)="closeModalBenefit()" *ngIf="isModalBenefitOpen">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn overflow-y-auto max-h-[80vh]" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900">
                Product Benefits
            </h2>
            <button (click)="closeModalBenefit()" class="text-gray-400 hover:text-gray-600 text-2xl">
                &times;
            </button>
        </div>

        <div *ngIf="selectedProduct; else noProductSelected">
            <div class="border-t pt-4">
                <h4 class="text-md font-semibold mb-3 text-gray-700">Benefits:</h4>
                <ul class="list-disc list-inside space-y-2" *ngIf="selectedProduct.properties?.benefit && selectedProduct.properties.benefit.length > 0; else noBenefits">
                    <li *ngFor="let benefit of selectedProduct.properties.benefit; let i = index; trackBy: trackByIndex" class="text-gray-700">
                        {{ benefit }}
                    </li>
                </ul>

                <ng-template #noBenefits>
                    <div class="text-center text-gray-400 py-4">
                        No benefits available for this product.
                    </div>
                </ng-template>
            </div>
        </div>

        <ng-template #noProductSelected>
            <div class="text-center text-gray-500">
                No product selected.
            </div>
        </ng-template>
    </div>
</div>
